import { createSlice } from "@reduxjs/toolkit";

export const notificationSlice = createSlice({
  name: "notificationsList",
  initialState: {
    notificationsData: {},
  },
  reducers: {
    setNotifications: (state, action) => {
      state.notificationsData = action.payload;
    },
  },
});

export const { setNotifications } = notificationSlice.actions;
export default notificationSlice.reducer;
